import { render, staticRenderFns } from "./Destaques.vue?vue&type=template&id=30b49d59&scoped=true&"
import script from "./Destaques.vue?vue&type=script&lang=js&"
export * from "./Destaques.vue?vue&type=script&lang=js&"
import style0 from "./Destaques.vue?vue&type=style&index=0&id=30b49d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b49d59",
  null
  
)

export default component.exports